import {css} from '@emotion/react'
import DownloadBadge from './DownloadBadge'
import DynamicDownloadButton from './DynamicDownloadButton'

const ConditionalDownloadCTA = ({
    isMobileDevice,
    languageCode,
    experimentId,
    os,
    browser,
    ctaType,
    downloadBadgeOverrideStyles,
    mobileWrapperStyles,
    desktopWrapperStyles,
}) => {
    if (isMobileDevice) {
        return (
            <div
                className="cta-mobile"
                css={[
                    css`
                        display: flex;
                        justify-content: center;
                        width: 100%;
                    `,
                    mobileWrapperStyles,
                ]}
            >
                <DynamicDownloadButton
                    languageCode={languageCode}
                    experiment={experimentId}
                    os={os}
                    browser={browser}
                    ctaType={ctaType}
                />
            </div>
        )
    }

    return (
        <div
            className="cta-desktop"
            css={[
                css`
                    display: flex;
                    @media (max-width: 880px) {
                        justify-content: center;
                    }
                `,
                desktopWrapperStyles,
            ]}
        >
            <DownloadBadge languageCode={languageCode} overrideStyles={downloadBadgeOverrideStyles} />
        </div>
    )
}

export default ConditionalDownloadCTA
